<!-- 停车管理 -->
<style lang="scss" scoped>
.returnScence {
  pointer-events: all;
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 135px;
  cursor: pointer;
  background-image: url("../../../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../../../assets/pagesImg/returnBtn-active.png");
  }
}

.left {
  position: absolute;
  top: 135px;
  left: 107px;
}

.right {
  position: absolute;
  right: 43px;
  top: 135px;
  .dialog_position {
    margin-top: 65px;
    margin-left: 19px;
  }
}
</style>
<template>
  <div class="parking-container">
    <div class="returnScence" @click="returnScence"></div>
    <div class="right">
      <CarSearch @sendSearch="searchData"></CarSearch>
      <div class="dialog_position">
        <!-- <gate-way
          v-show="showDialog"
          :headerName="'车位信息'"
          :pannelDatas="pannelDatas"
          :number="number"
        ></gate-way> -->
        <gate-way
          v-show="showDialog"
          :headerName="'车辆信息'"
          :pannelDatas="pannelDatas"
          :carUrl="carUrl"
        ></gate-way>
      </div>
      <!-- <CarInfor :LicensePlate="LicensePlate"></CarInfor>
      <CarLotInfor :number="number"></CarLotInfor>
      <CarcomeTime :comeTime="comeTime"></CarcomeTime> -->
    </div>
    <div class="left">
      <ParkingSpace :numb="numb"></ParkingSpace>
      <ChargingPile :chargingPile="chargingPile"></ChargingPile>
      <SurplusSpace :count="count" :clickData="clickData"></SurplusSpace>
      <Gate :barrier="barrier"></Gate>
    </div>
  </div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
import { getParkData, getEqpInfo, getParkByPlate } from "@/api/index";
import ParkingSpace from "./components/parking-space.vue";
import ChargingPile from "./components/charging-pile.vue";
import SurplusSpace from "./components/surplus-space.vue";
import CarInfor from "./components/car-infor.vue";
import CarLotInfor from "./components/carLot-infor.vue";
import CarcomeTime from "./components/carcome-time.vue";
import Gate from "./components/gate.vue";
import CarSearch from "./components/car-search.vue";
export default {
  created() {
    this.$store.state.threeEvent.intoParking = true;
    bus.emit("parking", true);
    bus.on("parkingArea", this.clickParkingArea);
    bus.on("clickCar", this.clickCar);
    this.ReqgetParkData();
    this.timer = setInterval(() => {
      this.ReqgetParkData();
    }, 30*60*1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  data() {
    return {
      numb: "0/0", //实时剩余车位
      barrier: {}, //道闸
      chargingPile: {}, // 充电桩
      count: {}, //剩余车位
      clickData: "A",
      showDialog: false,
      //车牌 编号 入场时间
      pannelDatas: {
        LicensePlate: "",
        number: "",
        comeTime: "",
      },
      carUrl: {},
      timer: null,
    };
  },
  methods: {
    clickParkingArea(names) {
      this.clickData = names;
    },
    async clickCar(eqpCode) {
      let { data: res } = await getEqpInfo({ eqpCode });
      if (res?.collectionValue) {
        let { 状态, 入场时间, 车位状况 } = res.collectionValue.data;
        let { eqpName } = res.collectionValue;
        //车牌
        this.pannelDatas.LicensePlate = 状态;
        //入场时间
        this.pannelDatas.comeTime = 入场时间;
        // 编号
        this.pannelDatas.number = eqpName;
        // 车图片
        this.carUrl = 车位状况;
        this.showDialog = true;
      } else {
        this.pannelDatas.LicensePlate = "--";
        this.pannelDatas.comeTime = "--";
        this.pannelDatas.number = "--";
      }
    },
    returnScence() {
      bus.emit("parking-mr");
      bus.emit("initCar");
      this.showDialog = false;
    },
    async ReqgetParkData() {
      let { data: res } = await getParkData();
      let { used } = res;
      bus.emit("getCarPoint", used);
      this.chargingPile = res.chargingPile;
      this.barrier = res.barrierGate;
      this.numb = res.serviceCondition;
      this.count = res.parkCount;
    },
    // 查询车牌
    async ReqgetParkByPlate(e) {
      let { data: res } = await getParkByPlate({ plateNum: e });
      if (!res) {
        this.showDialog = false;
        return;
      }
      // 聚焦场景
      this.clickCar(...res);
      bus.emit("carInfor", res[0]);
    },
    // 搜索车牌号
    searchData(e) {
      // 精准查询
      if (!e || e.length < 7) {
        this.showDialog = false;
        return;
      }
      this.ReqgetParkByPlate(e.toUpperCase());
    },
  },
  components: {
    ParkingSpace,
    ChargingPile,
    SurplusSpace,
    CarInfor,
    CarLotInfor,
    CarcomeTime,
    Gate,
    CarSearch,
  },
};
</script>
